import React from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import MSClientIdField from "./MSClientIdField";
import MSTenantIdField from "./MSTenantIdField";
import * as deviceService from "../deviceService";
import * as modalDataService from './modalDataService';


function MSConnectionFieldset({ hostName, msSubject, error, disabled }) {

    // const [anchorEl, setAnchorEl] = useState(null);

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    const generateCertificate = async() => {
        //handleClose();
        await deviceService.generateMSCertificate(hostName, msSubject);
    };

    const onSubjectChange = (value) => modalDataService.changeMSSubject(value);

    return (
        <fieldset className="oct_fieldset oct_fieldset-inner">
            <div className="row modal-v2-form-grid">
                <div className="col-md-7 modal-v2-grid-field">
                    <div className="form-group">
                        <div className="oct_form-group oct_form-sm">
                            <label htmlFor="ms_subject">Subject <span className="modal-v2-required-mark">*</span></label>
                            <input className={`form-control oct_field ${error && 'border-danger'}`}
                                id="ms_subject-key"
                                disabled={disabled}
                                value={msSubject}
                                placeholder="VarApp/O=MyCompany/C=US"
                                onChange={event => onSubjectChange(event.target.value)} />
                            <div className="modal-v2-field-help">Default: VarApp/O=MyCompany/C=US</div>
                        </div >                
                    </div>
                </div>
                <div className="col-md-5 modal-v2-grid-field">
                    <div className="form-group">
                        <div className="oct_form-group oct_form-sm">
                            <label className="d-none d-md-block">&nbsp;</label>
                            {/* <button className="oct_settings-btn-v2" */}
                            <button className="btn modal-v2-btn modal-v2-btn-primary w-100"
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    generateCertificate();
                                }} 
                                
                            >
                                Generate & Download Certificate
                            </button>
                        </div>
                    </div>
                </div> 
            </div>
                             
              
            <MSTenantIdField disabled={disabled} />
            <MSClientIdField disabled={disabled} /> 
                     
        </fieldset>
    )

}

function mapStateToProps(state) {
    debug("MSConnectionFieldset mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        hostName: addDeviceModal.hostName || "",
        msSubject: addDeviceModal.msSubject || '',       
        error: validation.msSubject
    }
}

export default connect(mapStateToProps)(MSConnectionFieldset);
